// extracted by css-extract-rspack-plugin
export default {"root":"SelectedGroupsList_root__vf7BW","list-item":"SelectedGroupsList_list-item__Y1Clf"};